import { guardado } from './armazenamento';
import { CARD_PADRAO } from './constantes';

function lerCamposCard() {
  return { ...CARD_PADRAO, ...guardado.lerJSON('camposCard', {}) };
}

// ─── C-27 / M-55: exportação CSV ──────────────────────────

export { lerCamposCard };
